<div>
  <glxy-form-field appearance="outline">
    <input
      matInput
      placeholder="{{ 'INBOX.NEW_MESSAGE.PHONE_NUMBER_EMAIL_OR_CONTACT_NAME' | translate }}"
      [formControl]="control"
      name="contact"
      (input)="searchChanged()"
      autocomplete="off"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto
      [displayWith]="displayContact"
      autoActiveFirstOption
      class="search-select-autocomplete"
      (optionSelected)="onOptionSelected($event)"
    >
      <mat-option *ngFor="let contact of contacts$ | async" [value]="contact" class="contact-info">
        <span class="glxy-option-text label">
          {{ displayContactInfo(contact).name }}
        </span>
        <br />
        <span class="glxy-option-text description">
          {{ displayContactInfo(contact).phoneAndEmail }}
        </span>
      </mat-option>
      @if (!(contacts$ | async)?.length) {
        <mat-option [id]="'add-contact'" [value]="control?.value" class="add-contact-option">
          <mat-icon aria-hidden="false" aria-label="add contact">add</mat-icon>
          <span class="label">{{ 'INBOX.EMPTY.ADD_CONTACT' | translate }}</span>
        </mat-option>
      }
    </mat-autocomplete>

    <glxy-error *ngIf="control.hasError('phone')">
      {{ 'INBOX.ERROR.INVALID_PHONE_NUMBER' | translate }}
    </glxy-error>
    <glxy-error *ngIf="control.hasError('invalidInput')">
      {{ 'INBOX.ERROR.INVALID_INPUT' | translate }}
    </glxy-error>
    <glxy-error *ngIf="control.hasError('invalidSelection')">
      {{ 'INBOX.ERROR.REQUIRED_FIELD' | translate }}
    </glxy-error>
  </glxy-form-field>
</div>
